import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { ColDef, GridApi } from 'ag-grid-community';
import { AssignmentViewModel } from 'src/app/shared/models/autogenerated';
import { AssignmentsMappingRendererComponent } from '../assignments-mapping-renderer/assignments-mapping-renderer.component';

@Component({
  standalone: false,
  selector: 'app-assignments-phases-table',
  templateUrl: './assignments-phases-table.component.html',
  styleUrls: ['./assignments-phases-table.component.scss'],
})
export class AssignmentsPhasesTableComponent implements OnChanges {
  @Input() rowData: AssignmentViewModel[] = [];
  @Output() filterByProjectPhase = new EventEmitter<{
    projectTitle: string;
    phaseId: string;
  }>();

  gridApi!: GridApi;
  configStoreTableName = 'assignmentsTablePhases';
  transformedRowData: any[] = [];

  components = {
    assignmentsMappingRenderer: AssignmentsMappingRendererComponent,
  };

  columnDefs: ColDef[] = [
    {
      headerName: 'Project',
      field: 'projectTitle',
      minWidth: 400,
      sortable: true,
      filter: true,
    },
    {
      headerName: 'Phase',
      field: 'phaseId',
      minWidth: 150,
      sortable: true,
      filter: true,
    },
    {
      headerName: 'Map',
      colId: 'map',
      minWidth: 90,
      maxWidth: 90,
      pinned: 'left',
      filter: 'agNumberColumnFilter',
      valueGetter: ({ data }) => data.assignmentCount ?? 0,
      type: 'centerAligned',
      cellRenderer: 'assignmentsMappingRenderer',
      cellRendererParams: {
        onMappingClick: (data: any) => {
          this.filterByProjectPhase.emit({
            projectTitle: data.projectTitle,
            phaseId: data.phaseId,
          });
        },
      },
    },
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['rowData']?.currentValue !== changes['rowData']?.previousValue
    ) {
      this.transformedRowData = this.groupByProjectAndPhase(this.rowData);
    }
  }

  groupByProjectAndPhase(data: AssignmentViewModel[]): any[] {
    const groupedMap = new Map<string, any>();

    data.forEach((item) => {
      const projectTitle = item.project?.name || 'Unknown Project';
      const phaseId = item.phase?.phaseId || 'Unknown Phase';
      const key = `${projectTitle}_${phaseId}`;

      if (!groupedMap.has(key)) {
        groupedMap.set(key, {
          projectTitle,
          phaseId,
          assignmentCount: 1,
        });
      } else {
        groupedMap.get(key).assignmentCount++;
      }
    });

    return Array.from(groupedMap.values());
  }
}
